import React from 'react'
import Hero from '../components/Hero'
import Slider from '../components/slider'
import About from '../components/About'
import OurTokenomics from '../components/OurTokenomics'
import Roadmap from '../components/roadmap'

export default function Home() {
  return (
    <>
      <Hero />
      <Slider />
      <About />
      <OurTokenomics />
      <Roadmap />
    </>
  )
}
